define.alias("shared/components/shared/expandable-radio-card-group", "media/components/shared/expandable-radio-card-group");